// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster, toast } from "react-hot-toast";

import { apiInstance } from "./config/apiConfig";

/* pages (unchanged) */
import HomePage       from "./pages/homepage";
import Login          from "./pages/login";
import Signup         from "./pages/signup";
import Forgotpassword from "./pages/forgotpassword";
import Dashboard      from "./pages/dashboard/dashboard";
import Create         from "./pages/createorder/createorder";
import Order          from "./pages/orders/order";
import Settings       from "./pages/settings/settings";
import Subscription   from "./pages/subscription/subscription";
import User           from "./pages/user/user";
import Thankyou       from "./pages/thankyou/thankyou";
import ResetPassword  from "./pages/ResetPassword";
import ProtectedRoute from "./pages/ProtectedRoute ";
import { AuthProvider } from "./auth/AuthContext";

import "./App.scss";

export default function App() {
  const [clientId, setClientId] = useState("");

  /* fetch Google OAuth client-id once */
  useEffect(() => {
    apiInstance
      .get("/config/google-client-id")
      .then(({ data }) => setClientId(data.clientId))
      .catch(err => console.error("Google client-id fetch failed", err));
  }, []);

 

  if (!clientId) return <div>Loading…</div>;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* public routes */}
            <Route path="/"               element={<HomePage />} />
            <Route path="/login"          element={<Login />} />
            <Route path="/signup"         element={<Signup />} />
            <Route path="/forgotpassword" element={<Forgotpassword />} />
            <Route path="/resetpassword"  element={<ResetPassword />} />

            {/* protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Outlet />}>
                <Route index element={<Dashboard />} />
                <Route path="create"       element={<Create />} />
                <Route path="settings"     element={<Settings />} />
                <Route path="subscription" element={<Subscription />} />
                <Route path="orders"       element={<Order />} />
                <Route path="users"        element={<User />} />
                <Route path="thankyou"     element={<Thankyou />} />
              </Route>
            </Route>
          </Routes>
        </Router>

        {/* one global toaster */}
        <Toaster
          position="bottom-center"
          toastOptions={{ duration: 3000, style: { zIndex: 99999 } }}
        />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
